import { Box, Divider, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
export const StyledBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.regular,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
}));
export const StyledGridBorder = styled(Grid)(({ theme }) => ({
  borderRight: theme.borders.highlighted,
  [theme.breakpoints.down("mb")]: {
    borderRight: "none",
    
  },
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  color: theme.palette.custom.orderName,
  padding: " 23px 18px",
}));

export const StyledTypographyTracking = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  [theme.breakpoints.down("xl")]: {
    fontSize: theme.typography.small.fontSize,
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: theme.typography.base.fontSize,
  },
}));
export const StyledTypographyDate = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.mini.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
}));
export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.custom.primary,
}));
export const OrderDetailsWrapper = styled(Box)(() => ({
  padding: "20px",
}));
export const StyledHeaderSection = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  padding: "16px 17px",
}));
export const StyledBoxFlex = styled(Box)(() => ({
  display: "flex",
  gap: "12px",
}));
export const StyledBoxStepper = styled(Box)(() => ({
  padding: "25px 0px",
}));
export const StyleBoxBg = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.screenBgColor,
}));
